<div class="mb-3" [class.has-error]="showError">
<label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
  {{ props.label }}
  <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
</label>

<ngx-json-viewer [json]="model.body"></ngx-json-viewer>
</div>
